import { useCallback } from "react";

export const useGatewayDidsMutation = ({
  rowsToUpdate,
  rowsToDelete,
  data,
  updateDids,
  deleteDids,
  setRowsToUpdate,
  setRowsToDelete,
  setData,
  handleUpdateResponse,
  handleDeleteResponse,
  errorNotification,
  trunkId,
  idKey,
}) => {
  return useCallback(() => {
    if (rowsToUpdate.size > 0) {
      const dids = [];
      rowsToUpdate.forEach((_, key) => {
        const row = data.find((did) => did.didId === key);
        if (row) dids.push(row);
      });

      updateDids({ trunkId, dids })
        .unwrap()
        .then(
          handleUpdateResponse({
            rowsToUpdate,
            setRowsToUpdate,
            setData,
            idKey,
          })
        )
        .catch(errorNotification);
    }

    if (rowsToDelete.size > 0) {
      deleteDids({
        trunkId,
        didIds: Array.from(rowsToDelete.keys()),
      })
        .unwrap()
        .then(
          handleDeleteResponse({
            rowsToDelete,
            setRowsToDelete,
            setData,
            idKey,
          })
        )
        .catch(errorNotification);
    }
  });
};
